import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Column } from 'devextreme/ui/data_grid';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  private translateService = inject(TranslateService);

  asString<T>(rowData: T) {
    const col = this as Column;
    const value = rowData[col.dataField as keyof T] ?? null;
    return value?.toString() ?? '';
  }

  asStringTranslated<T>(prefix: string) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (this: any, rowData: T) {
      const col = this as Column;
      const value = rowData[col.dataField as keyof T] ?? null;
      const stringValue = value?.toString() ?? '';
      return self.translateService.instant(prefix + stringValue);
    };
  }
}
